<template>
	<div v-on-clickaway="collapse">
		<dp-field v-bind="$attrs">
			<div
				slot="label"
				:class="labelClass"
				class="field-label is-marginless"
				@keypress.enter.space="toggleExamine">
				<button
					v-if="!asDetail"
					ref="examineButton"
					:aria-label="$t('action.toggleDetails', [$t(labelKeyGuess)])"
					:class="{ 'is-focused': examined, [buttonClass]: true }"
					class="button has-text-weight-bold is-outlined is-rounded is-tiny"
					@click="toggleExamine">
					<dp-svg v-if="isValid(iconGuess)" :svg="iconGuess" />
					<template v-else>
						?
					</template>
				</button>
				<label v-t="labelKeyGuess" class="has-cursor-pointer" @click="toggleExamine" />
			</div>
			<slot />
		</dp-field>
		<dp-box
			v-if="examined || asDetail"
			:class="detailClasses"
			class="is-grid has-one-column has-row-gap is-small"
			simple>
			<p v-if="descriptionKeyGuess" class="has-text-info">
				{{ $t(descriptionKeyGuess, [descriptionValues] ) }}
			</p>
			<slot name="description" />
		</dp-box>
	</div>
</template>

<script>
import { find } from 'ramda';
import { camelConcat } from 'src/utils';
import { isKnownIcon } from 'src/widgets';

export default {
	name: 'DpDetailField',
	props: {
		buttonClass: { type: String, default: 'is-info' },
		buttonAriaLabel: { type: String, default: null },
		context: { type: String, default: null },
		icon: { type: String, default: null },
		anIcon: { type: String, default: null },
		labelClass: { type: String, default: null },
		labelKey: { type: String, default: null },
		descriptionKey: { type: String, default: null },
		descriptionValues: { type: Array, default: () => [] },
		asDetail: { type: Boolean, default: false },
	},
	data: () => ({ examined: false }),
	computed: {
		iconGuess() {
			return find(isKnownIcon, [
				this.icon,
				camelConcat(this.context, this.icon),
				camelConcat(this.context, this.labelKey),
			]);
		},
		labelKeyGuess() {
			return this.firstExistingKeyOf(
					this.labelKey,
					`${this.context}.${this.labelKey}`);
		},
		descriptionKeyGuess() {
			return this.descriptionKey || this.firstExistingKeyOf(
					`${this.context}.${this.descriptionKey}`,
					`${this.context}.${this.labelKey}Description`,
					`${this.labelKey}Description`);
		},
		detailClasses() { return { 'is-dark': !this.asDetail, 'is-darker': this.asDetail, 'has-bottom-margin': !this.asDetail }; },
	},
	methods: {
		collapse() { this.examined = false; },
		async toggleExamine() {
			this.examined = !this.examined;
			await this.$nextTick();
			if (this.examined) {
				this.$refs.examineButton.focus();
			}
		},
		firstExistingKeyOf(...options) { return find(this.$te.bind(this), options); },
		isValid(icon) {	return isKnownIcon(icon); },
	},
};

</script>

<style scoped>
.has-bottom-margin {
	margin-bottom: 0.5rem;
}
</style>
